<template>
	<div>
		<el-row>
			<el-col :xs="0" :sm="8" :md="8" :lg="8" :xl="8" :offset="8" style="text-align: center;">
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm">
				  <el-form-item label="公司名称" prop="company">
				    <el-input v-model="ruleForm.company" placeholder="请输入公司名称"></el-input>
				  </el-form-item>
				  <el-form-item label="联系人" prop="nickname">
				    <el-input v-model="ruleForm.nickname" placeholder="请输入联系人"></el-input>
				  </el-form-item>
				  <el-form-item label="职务" prop="duties">
				    <el-input v-model="ruleForm.duties" placeholder="请输入职务"></el-input>
				  </el-form-item>
				  <el-form-item label="邮箱" prop="email">
				    <el-input v-model="ruleForm.email" placeholder="请输入邮箱"></el-input>
				  </el-form-item>
				  <el-form-item label="手机" prop="mobile">
				    <el-input v-model="ruleForm.mobile" placeholder="请输入手机"></el-input>
				  </el-form-item>
				  <el-form-item label="账号" prop="username">
				    <el-input v-model="ruleForm.username" placeholder="请输入账号(仅限字母或数字)"></el-input>
				  </el-form-item>
				  <el-form-item label="登录密码" prop="password">
				    <el-input v-model="ruleForm.password" placeholder="请输入登录密码" type='password'></el-input>
				  </el-form-item>
<!-- 				  <el-form-item label="验证码" prop="captcha">
					  <el-row>
					  	<el-col :xs="12" :sm="20" :md="20" :lg="20" :xl="12">
							<el-input v-model="ruleForm.captcha" placeholder="请输入验证码"></el-input>
						</el-col>
						<el-col :xs="8" :sm="20" :md="20" :lg="20" :xl="8">
							<img :src="imgCodeSrc" width="100" height="25" style="vertical-align: middle;" @click="refreshCode()">
						</el-col>
				      </el-row>
				  </el-form-item> -->
				  <div style="font-size: 10px;width:100%;margin:10px auto;">
					  <el-checkbox v-model="checked"></el-checkbox>
				  <span style="margin-left: 5px;">点击注册表示您已阅读并同意</span>
				  <span @click="xieyi = true" style="cursor: pointer;color:#409EFF">《海润龙物流运输招标网服务协议》</span>
				  <span @click="yinsi = true" style="cursor: pointer;color:#409EFF">《海润龙物流运输招标网隐私政策》</span>
				  </div>
				  <el-form-item>
				    <el-button type="primary" @click="submitForm('ruleForm')">提交注册</el-button>
				  </el-form-item>
				</el-form>
			</el-col>
		</el-row>
		<!-- 用户协议 -->
		<el-dialog
		  title="用户协议"
		  :visible.sync="xieyi"
		  width="60%">
		  <div v-html="xieyiContent" style="max-height: 600px; overflow-y: auto;"></div>
		</el-dialog>
		<!-- 隐私政策 -->
		<el-dialog
		  title="隐私政策"
		  :visible.sync="yinsi"
		  width="60%">
		  <div v-html="yinsiContent" style="max-height: 600px; overflow-y: auto;"></div>
		</el-dialog>
		<!-- 手机端 -->
		<el-row>
			<el-col :xs="24" :sm="0" :md="0" :lg="0" :xl="0">
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm">
				  <el-form-item label="公司名称" prop="company">
				    <el-input v-model="ruleForm.company" placeholder="请输入公司名称"></el-input>
				  </el-form-item>
				  <el-form-item label="联系人" prop="nickname">
				    <el-input v-model="ruleForm.nickname" placeholder="请输入联系人"></el-input>
				  </el-form-item>
				  <el-form-item label="职务" prop="duties">
				    <el-input v-model="ruleForm.duties" placeholder="请输入职务"></el-input>
				  </el-form-item>
				  <el-form-item label="邮箱" prop="email">
				    <el-input v-model="ruleForm.email" placeholder="请输入邮箱"></el-input>
				  </el-form-item>
				  <el-form-item label="手机" prop="mobile">
				    <el-input v-model="ruleForm.mobile" placeholder="请输入手机" type="number"></el-input>
				  </el-form-item>
				  <el-form-item label="账号" prop="username">
				    <el-input v-model="ruleForm.username" placeholder="请输入账号(仅限字母或数字)"></el-input>
				  </el-form-item>
				  <el-form-item label="登录密码" prop="password">
				    <el-input v-model="ruleForm.password" placeholder="请输入登录密码" type='password'></el-input>
				  </el-form-item>
<!-- 				  <el-form-item label="验证码" prop="captcha">
					  <el-row>
					  	<el-col :xs="12" :sm="20" :md="20" :lg="20" :xl="12">
							<el-input v-model="ruleForm.captcha" placeholder="验证码"></el-input>
						</el-col>
						<el-col :xs="8" :sm="20" :md="20" :lg="20" :xl="8">
							<img :src="imgCodeSrc" width="100" height="25" style="vertical-align: middle;" @click="refreshCode()">
						</el-col>
				      </el-row>
				  </el-form-item> -->
				  <div style="font-size: 10px;width:100%;margin:10px auto;">
				  <el-checkbox v-model="checked"></el-checkbox>
				  <span style="margin-left: 5px;">点击注册表示您已阅读并同意</span>
				  <span @click="xieyi = true" style="cursor: pointer;color:#409EFF">《海润龙物流运输招标网服务协议》</span>
				  <span @click="yinsi = true" style="cursor: pointer;color:#409EFF">《海润龙物流运输招标网隐私政策》</span>
				  </div>
				  <el-form-item>
				    <el-button type="primary" @click="submitForm('ruleForm')">提交注册</el-button>
				  </el-form-item>
				</el-form>
			</el-col>
		</el-row>
	</div>
</template>

<script>
  export default {
	  metaInfo() {
	    return {
	  	title: '会员注册 - ' + this.metaName,
	  	meta: [{ charset: "utf-8",
	  	},{ 
	  		name: "keywords", 
	  	    content: this.metaKeywords,
	  	},{ 
	  		name: "description", 
	  	    content: this.metaDecs,
	  	  }],
	    }
	  },
    data() {
      return {
		metaName: "",
		metaKeywords: "",
		metaDecs: "",
		imgCodeSrc:this.$utils.httpUrl + 'captcha.html',
		checked:false,
		xieyi:false,
		yinsi:false,
		xieyiContent:'',
		yinsiContent:'',
        ruleForm: {
          company: '',
          username: '',
		  nickname:'',
          duties: '',
          email: '',
          // delivery: false,
          mobile: '',
          password: '',
		  captcha:''
        },
        rules: {
          company: [
            { required: true, message: '请输入公司名称', trigger: 'blur' },
            { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
          ],
          username:[
		   { required: true, message: '请输入账号', trigger: 'blur' },
		   {required:true, pattern:/^[a-zA-Z0-9]{3,20}$/ig, message: '长度在 3 到 20 个字母或数字', trigger:'blur'}
		  ],
		  nickname:[
		   { required: true, message: '请输入联系人', trigger: 'blur' },
		   { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' }
		  ],
          duties:[
		   { required: true, message: '请输入职务', trigger: 'blur' },
		   { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' }
		  ],
          email:[
		   { required: true, message: '请输入邮箱地址', trigger: 'blur' },
		   { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
		  ],
          mobile:[
		   { required: true, message: '请输入手机号码', trigger: 'blur' },
		   { min: 11, max: 11, message: '请输入正确的手机号码', trigger: 'blur' }
		  ],
          password:[
		   { required: true, message: '请输入密码', trigger: 'blur' }
		  ]
        }
      };
    },
	mounted() {
		this.$axios({
			url:this.$utils.httpApi + 'index/webconfig'
		}).then(res=>{
			this.metaName = res.data.data.webtitle
			this.metaDecs = res.data.data.webdescription
			this.metaKeywords = res.data.data.webkeywords
		})
		this.$axios({
			url:this.$utils.httpApi + 'index/xieyi'
		}).then(res=>{
			this.xieyiContent = res.data.data.xieyi
			this.yinsiContent = res.data.data.yinsi
		})
	},
    methods: {
      submitForm(formName) {
		if(this.checked){
			this.$refs[formName].validate((valid) => {
			  if (valid) {
			    this.$axios({
					
				   method:'post',
				   url:this.$utils.httpApi + 'user/reg',
				   data:this.ruleForm
			    }).then(res=>{
				   if(res.data.code == 0){
					   this.$message.error(res.data.msg);
				   }else{
					   this.$message.success(res.data.msg);
					   window.localStorage.setItem("token", res.data.data.userinfo.token);
					   window.location.reload();
				   }
			    })
			  } else {
				this.$alert('请输入必填项', '提交出错', {
				  confirmButtonText: '确定',
				});
			    return false;
			  }
			});
		}else{
			this.$message({
				message:'请阅读并同意服务协议',
				type:'error'
			})
			return false
		}

      },
	  refreshCode(){
		  this.imgCodeSrc = ''
		  setTimeout(()=>{
			  this.imgCodeSrc = this.$utils.httpUrl + 'captcha.html'
		  }, 10);
	  }
    }
  }
</script>

<style>
</style>